import { useTranslation } from "react-i18next";
import { Message, MessageTypes } from "./Message/Message";

const RuhmaImpexDeliveryWarning = () => {
  const { t } = useTranslation();

  return (
    <Message
      message={t("general.ri_delivery_estimate_warning")}
      type={MessageTypes.WARNING}
    />
  );
};

export default RuhmaImpexDeliveryWarning;
